import request from '@/utils/request'
export const Download = '/icps/system/sign/settlement/concreteSettle/exportList'
/**1.待结算-获取工程列表*/
export function get_engineering_list(data) {
  return request({
    url: '/icps/system/sign/settlement/concreteSettle/get_engineering_list',
    method: 'post',
    data
  })
}
/** 2.获取待结算物流列表*/
export const queryPage1 = '/icps/system/sign/settlement/concreteSettle/getLogisticsList'
/**3.生成结算单*/
export function generate_statement_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/concreteSettle/querySettleLogisticsDetail',
    method: 'post',
    data
  })
}
/**4.保存结算单*/
export function save_statementde_tail(data) {
  return request({
    url: '/icps/system/sign/settlement/concreteSettle/saveSettleMentDetail',
    method: 'post',
    data
  })
}
/**4.修改结算单*/
export function update_statementde_tail(data) {
  return request({
    url: '/icps/system/sign/settlement/concreteSettle/updateSettleMentDetail',
    method: 'post',
    data
  })
}
/**5.获取已结算物流列表*/
export const queryPage2 = '/icps/system/sign/settlement/concreteSettle/getAlreadySettleData'
/**6.分页获取结算单列表*/
export const queryPage3 = '/icps/system/sign/settlement/concreteSettle/queryPage'
/**7.查看结算单详情*/
export function get_statement_detail(params) {
  return request({
    url: '/icps/system/sign/settlement/concreteSettle/getSettleMentDetail',
    method: 'GET',
    params
  })
}
/**8.发送给客户*/
export function send_to_customer(data) {
  return request({
    url: '/icps/system/sign/settlement/beton/betonStatement/send_to_customer',
    method: 'post',
    data
  })
}
/**9.修改审核状态或客户确认状态*/
export function update_status(data) {
  return request({
    url: '/icps/system/sign/settlement/concreteSettle/updateSettleStatus',
    method: 'post',
    data
  })
}
/**9.修改审核状态或客户确认状态*/
export function get_users(params) {
  return request({
    url: '/icps/system/sign/settlement/beton/betonStatement/get_users',
    method: 'GET',
    params
  })
}

/**10.获取销售员*/
export function querySallerOrBudget(params) {
  return request({
    url: '/icps/system/sign/settlement/concreteSettle/querySallerOrBudget',
    method: 'GET',
    params
  })
}

/**11.结算补差 */
export function generate_statement_compensate(data) {
  return request({
    url: '/icps/system/sign/settlement/settlementCompensate/generate_statement_compensate',
    method: 'post',
    data
  })
}













